import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { S25RuleTreeModule } from "./s25.rule.tree.module";
import { Rules } from "./s25.rule.const";
import type { SearchCriteriaType } from "../../pojo/SearchCriteriaI";

@Component({
    selector: "s25-ng-ingestion-field-rules",
    template: `
        @if (formId()) {
            <s25-ng-rule-tree
                [category]="category()"
                [subCategory]="subCategory()"
                [subCategoryPrefix]="subCategoryPrefix()"
                [conditionFilterMap]="conditionFilterMap()"
                [searchCriteriaType]="searchCriteriaType()"
                [searchCriteriaPicker]="picker()"
                [searchCriteriaSingleSelect]="singleSelect()"
            ></s25-ng-rule-tree>
        } @else {
            <p class="no-form-context">Select a form context for this action to configure rules.</p>
        }
    `,
    styles: `
        .no-form-context {
            margin: 0;
            color: var(--color--text-muted);
        }
    `,
    standalone: true,
    imports: [S25RuleTreeModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class S25IngestionFieldRulesComponent {
    readonly category = input.required<Rules.Category>();
    readonly subCategory = input<string | undefined>();
    readonly subCategoryPrefix = input<string | undefined>();
    readonly formId = input<number | undefined>();
    readonly searchCriteriaType = input.required<SearchCriteriaType["type"]>();
    readonly picker = input.required<"dropdown" | "multiselect">();
    readonly singleSelect = input(false);

    readonly conditionFilterMap = computed<Rules.ConditionFilterMap>(() => {
        const formId = this.formId();
        if (!formId) return {};
        return { ingestionFieldsAll: String(formId) };
    });
}
